module.exports = __webpack_public_path__ + "img/1991spwg.378d74d5.png";